module.exports = __webpack_public_path__ + "static/media/ABOUT CLIENT  DASHBOARD.57ea733d.png";